<template>
    <wrapper>
        <search-filter-generator :model.sync="model" :formConfig="formConfig">
            <div class="search-filter-btn-group">
                <el-button type="primary" plain @click="search" size="small" round>查询</el-button>
                <el-button @click="reset" size="small" round>重置</el-button>
            </div>
        </search-filter-generator>
    </wrapper>
</template>
<script>
    import wrapper from "./wrapper"
    import {searchFilterGenerator} from "@/plugins/form-generator/index.js"

    export default {
        name: "search-filter",
        components: {wrapper, searchFilterGenerator},
        props: {
            model: Object,
            resetModel: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            asyncConfig: Array,
            formConfig: Array
        },
        methods: {
            search() {
                this.$emit("search", this.model)
            },
            reset() {
                for (let i in this.model) {
                    this.model[i] = this.resetModel[i] ? this.resetModel[i] : ""
                }
                this.$emit("reset", this.model)
            },
            change(item) {
                let model = Object.assign({}, this.model, item)
                this.$emit("search", model)
            }
        },
        created() {
            let self = this
            document.onkeyup = function (e) {
                let event = e || window.event
                let key = event.which || event.keyCode || event.charCode
                if (key === 13) {
                    self.search()
                }
            }
        }
    }
</script>
<style scoped lang="scss">
    .search-filter-btn-group {
        display: flex;
        align-items: flex-end;
        padding-bottom: 12px;
    }
</style>
